import React from 'react';
import { CodeBracketIcon, CubeIcon, ServerIcon } from '@heroicons/react/24/outline';
import { usePortfolioData } from '../context/PortfolioDataContext';
import AnimatedSection from './AnimatedSection';
import SectionWithNeuralBg from './SectionWithNeuralBg';

const iconMap = {
  code: CodeBracketIcon,
  cube: CubeIcon,
  server: ServerIcon,
};

export default function Services() {
  const { data } = usePortfolioData();
  const services = data.services;

  return (
    <SectionWithNeuralBg id="services" className="py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <AnimatedSection className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-primary-900/30 rounded-full flex items-center justify-center border border-primary-800/50">
              <CodeBracketIcon className="w-8 h-8 text-primary-400" />
            </div>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            What I Do
          </h2>
          <p className="text-lg text-gray-400">
            Specialized in building modern web applications with cutting-edge technologies
          </p>
        </AnimatedSection>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            return (
              <AnimatedSection
                key={index}
                delay={index * 120}
                className="card group hover:border-primary-700 hover:shadow-xl hover:shadow-primary-900/20 transition-all duration-300">
                {/* Icon */}
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-primary-900/30 text-primary-400 group-hover:bg-primary-600 group-hover:text-white group-hover:scale-110 transition-all duration-300 border border-primary-800/50">
                    {Icon && <Icon className="w-7 h-7" />}
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-gradient transition-all">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors">
                  {service.description}
                </p>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </SectionWithNeuralBg>
  );
}
